export default "__VITE_ASSET__26233bc2__"